import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  noChatbotLogs: {
    id: 'app.containers.Chatbot.noChatbotLogs',
    defaultMessage: `No bot messages yet!`,
  },
});
